module.exports = __webpack_public_path__ + "podaci.0ce36f619b4899f63d7c.jpg";